import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import {
  CartProvider,
  WishlistProvider,
  AuthProvider,
  useAuth,
} from './context/AppContext';

import Navbar        from './components/Navbar';
import Footer        from './components/Footer';
import LoadingScreen from './components/LoadingScreen';

import Home          from './pages/Home';
import Collections   from './pages/Collections';
import ProductDetail from './pages/ProductDetail';
import Cart          from './pages/Cart';
import Checkout      from './pages/Checkout';
import OrderSuccess  from './pages/OrderSuccess';
import Login         from './pages/Login';
import About         from './pages/About';
import Contact       from './pages/Contact';
import MyOrders      from './pages/MyOrders';
import Wishlist from './pages/Wishlist';

import AdminLogin    from './pages/admin/AdminLogin';
import AdminDashboard from './pages/admin/AdminDashboard';
import AdminProducts  from './pages/admin/AdminProducts';
import AdminAddProduct from './pages/admin/AdminAddProduct';
import AdminOrders    from './pages/admin/AdminOrders';
import AdminInquiries from './pages/admin/AdminInquiries';
import ScrollToTop from './components/ScrollToTop';
import AdminOrderDetails from './pages/admin/AdminOrderDetails';

function AdminRoute({ children }) {
  const { isAdmin } = useAuth();
  return isAdmin ? children : <Navigate to="/admin/login" replace />;
}
  
function AppRoutes() {
  return (
    <Routes>
      {/* Public */}
      <Route path="/" element={<><Navbar /><Home /><Footer /></>} />
      <Route path="/collections" element={<><Navbar /><Collections /><Footer /></>} />
      <Route path="/collections/:category" element={<><Navbar /><Collections /><Footer /></>} />
      <Route path="/product/:id" element={<><Navbar /><ProductDetail /><Footer /></>} />
      <Route path="/cart" element={<><Navbar /><Cart /><Footer /></>} />
      <Route path="/checkout" element={<><Navbar /><Checkout /><Footer /></>} />
      <Route path="/order-success/:id" element={<><Navbar /><OrderSuccess /><Footer /></>} />
      <Route path="/login" element={<><Navbar /><Login /><Footer /></>} />
      <Route path="/about" element={<><Navbar /><About /><Footer /></>} />
      <Route path="/contact" element={<><Navbar /><Contact /><Footer /></>} />
      <Route path="/my-orders" element={<><Navbar /><MyOrders /><Footer /></>} />
      <Route path="/wishlist" element={<><Navbar /><Wishlist /><Footer /></>} />


      {/* Admin */}
      <Route path="/admin/login" element={<AdminLogin />} />
      <Route path="/admin" element={<AdminRoute><AdminDashboard /></AdminRoute>} />
      <Route path="/admin/products" element={<AdminRoute><AdminProducts /></AdminRoute>} />
      <Route path="/admin/products/add" element={<AdminRoute><AdminAddProduct /></AdminRoute>} />
      <Route path="/admin/products/edit/:id" element={<AdminRoute><AdminAddProduct /></AdminRoute>} />
      <Route path="/admin/orders" element={<AdminRoute><AdminOrders /></AdminRoute>} />
      <Route path="/admin/inquiries" element={<AdminRoute><AdminInquiries /></AdminRoute>} />
<Route
  path="/admin/orders/:id"
  element={
    <AdminRoute>
      <AdminOrderDetails />
    </AdminRoute>
  }
/>  
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>

    
  );
}

export default function App() {
  return (
    <AuthProvider>
      <WishlistProvider>
        <CartProvider>
          <Router>
            <ScrollToTop />
            <LoadingScreen />
            <AppRoutes />

            <Toaster
              position="bottom-right"
              toastOptions={{
                style: {
                  fontFamily: 'Jost, sans-serif',
                  fontSize: '14px',
                },
                success: {
                  style: {
                    background: '#6B1B2A',
                    color: 'white',
                  },
                },
              }}
            />
          </Router>
        </CartProvider>
      </WishlistProvider>
    </AuthProvider>
  );
}